import React, { useContext } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"
import { Navigation, Pagination } from "swiper"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"
import { isMobileContext } from "../context/isMobileContext"

export default function Infrastructure({
	data,
	section,
	normalSwiperLayers,
	uniqueClass,
	invertedSwiper,
	diversitySwiper,
	environmentLayer,
	environmentLayer2,
	environmentMobileLayer
}) {
	const { t, i18n } = useTranslation()
	const { isMobile } = useContext(isMobileContext)

	return (
		<div className={`infrastructure ${uniqueClass}
		${environmentMobileLayer ? "environmentMobileLayer" : ""}
		`}>
			<div
				className={`infrastructure-container
				${invertedSwiper ? "invertedSwiper" : ""} 
				${normalSwiperLayers ? "normalSwiperLayers" : ""}
				${environmentLayer ? "environmentLayer" : ""}
				${environmentLayer2 ? "environmentLayer2" : ""}
				 
				`}
			>
				<div className="info">
					<div className="subtitle-container">
						<motion.h3
							initial={{ opacity: 0, translateY: "100%" }}
							whileInView={{ opacity: 1, translateY: 0 }}
							viewport={{ once: true }}
							transition={{ ease: "easeInOut", duration: 0.7, delay: 0.25 }}
						>
							{data.subtitle}
						</motion.h3>
					</div>
					<div className="title-container">
						<div className="first-word">
							<motion.h2
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 0.5 }}
							>
								{data.title1}
							</motion.h2>
						</div>
						{data.title2 && (
							<div className="second-word">
								<motion.h2
									initial={{ opacity: 1, translateY: "100%" }}
									whileInView={{ opacity: 1, translateY: 0 }}
									viewport={{ once: true }}
									transition={{ ease: "easeInOut", duration: 0.7, delay: 0.75 }}
								>
									{data.title2}
								</motion.h2>
							</div>
						)}
					</div>
					<motion.p
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						viewport={{ once: true }}
						transition={{ ease: "easeInOut", duration: 0.7, delay: 1 }}
						className="desc"
					>
						{data.desc}
					</motion.p>
				</div>
				<div className="swiper-container">
					{!isMobile && (
						<motion.div
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{
								ease: "easeInOut",
								delay: isMobile ? 0.6 : 1,
								duration: 0.5,
							}}
							className={`infra-navigation-container
							${data.cardsData.length < 3 && "d-none"}
							`}
						>
							<div
								className={`swiper-button-prev infra-prev infra-prev-${section}`}
							></div>
							<div
								className={`swiper-button-next infra-next infra-next-${section}`}
							></div>
						</motion.div>
					)}
					<Swiper
						key={Math.random(0, 100)+i18n.language}
						style={
							invertedSwiper?{ direction: i18n.language === "ar" ? "ltr" : "rtl" }
							:
							{ direction: i18n.language === "ar" ? "rtl" : "ltr" }
						}
						breakpoints={{
							0: {
								slidesPerView: 1,
								spaceBetween: 0,
							},
							1024: {
								slidesPerView: 2,
								spaceBetween: 0,
							},
						}}
						modules={[Navigation]}
						navigation={{
							nextEl: `.infra-next-${section}`,
							prevEl: `.infra-prev-${section}`,
						}}
						className="infra-swiper"
					>
						{data.cardsData.map((item, index) => (
							<SwiperSlide key={index}>
								<motion.div
									initial={{ opacity: 0 }}
									whileInView={{ opacity: 1 }}
									viewport={{ once: true }}
									transition={{
										ease: "easeInOut",
										delay: isMobile
											? 0.3 + parseFloat(index * 0.055)
											: 0.75 + parseFloat(index / 10),
										duration: 0.5,
									}}
									className="infra-card"
								>
									<h4 className="title">{item.title}</h4>
									<div className="vector-container">
										<img
											src={
												process.env.PUBLIC_URL + "/imgs/achievements/line.svg"
											}
											alt="separator"
										/>
									</div>
									<div className="image-container">
										<img src={process.env.PUBLIC_URL + item.img} alt="img" />
									</div>
								</motion.div>
							</SwiperSlide>
						))}
					</Swiper>
					{isMobile && (
						<motion.div
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{
								ease: "easeInOut",
								delay: isMobile ? 0.6 : 1,
								duration: 0.5,
							}}
							className={`infra-navigation-container
							${data.cardsData.length === 1 && "d-none"}
							`}
						>
							<div
								className={`swiper-button-prev infra-prev infra-prev-${section}`}
							></div>
							<div
								className={`swiper-button-next infra-next infra-next-${section}`}
							></div>
						</motion.div>
					)}
				</div>
				{normalSwiperLayers && !diversitySwiper && (
					<>
						{/* <div className="back-layer3">
							<img
								src={
									process.env.PUBLIC_URL + "/imgs/achievements/back-layer3.png"
								}
								alt="back-layer"
							/>
						</div> */}
						{/* <div className="back-layer1">
                        <img src="/imgs/achievements/back-layer2.png" alt="back-layer" />
                    </div> */}
					</>
				)}
				{invertedSwiper && (
					<>
						<div className="back-layer4 mobile">
							<img
								src={
									process.env.PUBLIC_URL + "/imgs/achievements/back-layer4.png"
								}
								alt="back_layer"
							/>
						</div>
					</>
				)}
				{normalSwiperLayers && (
					<div className="back-layer4">
						<img
							src={
								process.env.PUBLIC_URL +
								"/imgs/home-page/statement-back-layer4.svg"
							}
							alt="back-layer"
						/>
					</div>
				)}
				{environmentLayer2 ? (
					<>
						<div className="back-layer4">
							<img
								src={
									process.env.PUBLIC_URL +
									"/imgs/home-page/statement-back-layer4.svg"
								}
								alt="back-layer"
							/>
						</div>
						<div className="back-layer4 bg2">
							<img
								src={
									process.env.PUBLIC_URL + "/imgs/achievements/back-layer4.png"
								}
								alt=""
							/>
						</div>
					</>
				) : ""}
				{environmentLayer ? (
					<>
						<div className="back-layer4">
							<img
								src={
									process.env.PUBLIC_URL +
									"/imgs/home-page/statement-back-layer4.svg"
								}
								alt="back-layer"
							/>
						</div>
						<div className="back-layer4">
							<img
								src={
									process.env.PUBLIC_URL + "/imgs/achievements/back-layer4.png"
								}
								alt=""
							/>
						</div>
					</>
				) : ""}
			</div>
				{environmentMobileLayer && (
					<div className={`mobile-bg`}>
						<img
							src={process.env.PUBLIC_URL + '/imgs/appendices/partners-bg2.png'}
							alt='background'
						/>
					</div>
				)}
		</div>
	)
}
